const ArrowUpwards = (props: { className: any; onClick?: any }) => {
  const { className } = props;

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" fill="none">
      <path
        d="M17 11L13.7071 14.2152C13.3182 14.5949 12.6818 14.5949 12.2929 14.2152L9 11"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default ArrowUpwards;
